function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:12;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#1CC29F;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#52595F;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#ACE4D6;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#373B3F;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group-2"
}, React.createElement("polygon", {
  id: "stroke",
  className: "st0",
  points: "9.9,31.8 53.5,6.6 97.1,31.8 97.1,99.3 9.9,99.3  "
}), React.createElement("polygon", {
  id: "bg",
  className: "st1",
  points: "9.9,32.3 53.5,7.1 97.1,32.3 97.1,99.8 9.9,99.8  "
}), React.createElement("g", {
  id: "assets_x2F_logo_x2F_primary"
}, React.createElement("path", {
  id: "Fill-1",
  className: "st2",
  d: "M42.7,63.6l10.6-6.1l-44-25.4v25.1c3.3-1.8,7.5-2.7,12.2-2.7C31.8,54.5,38.4,58.9,42.7,63.6"
}), React.createElement("path", {
  id: "Fill-4",
  className: "st2",
  d: "M23.3,98.6c4.4,0,7.7-1.3,7.7-4.6c0-3.4-4.3-4.7-9.5-6c-3.9-1-8.4-2-12.2-3.9v6.4 C12.4,95.6,17.7,98.6,23.3,98.6"
}), React.createElement("polygon", {
  id: "Fill-6",
  className: "st3",
  points: "97.2,82.9 97.2,32.1 53.2,57.5  "
}), React.createElement("polygon", {
  id: "Fill-9",
  className: "st4",
  points: "97.2,32.1 53.2,6.7 9.2,32.1 53.2,57.5  "
}), React.createElement("path", {
  id: "Fill-12",
  className: "st5",
  d: "M53.2,57.5l-10.6,6.1l-11.3,6.5c-2.9-2.3-6.6-4-10-4c-4.1,0-6.2,1.4-6.2,3.9 c0,2.9,2.9,4.3,6.8,5.4c0.8,0.2,1.7,0.5,2.6,0.7C33.4,78.3,45.1,81,45.1,93c0,2.5-0.5,5-1.7,7.3h53.8V82.9L53.2,57.5z"
}), React.createElement("path", {
  id: "Fill-14",
  className: "st0",
  d: "M24.6,76.2c-0.9-0.2-1.8-0.5-2.6-0.7c-4-1.1-6.8-2.5-6.8-5.4c0-2.5,2.1-3.9,6.2-3.9 c3.4,0,7.1,1.7,10,4l11.3-6.5c-4.3-4.7-10.9-9.1-21.2-9.1c-4.8,0-8.9,0.9-12.2,2.7v25.7v1.2C13,86,17.5,87,21.4,88 c5.3,1.3,9.5,2.6,9.5,6c0,3.3-3.3,4.6-7.7,4.6c-5.6,0-10.8-3-14-8.1v9.8h34.1c1.2-2.3,1.7-4.8,1.7-7.3 C45.1,81,33.4,78.3,24.6,76.2"
})));

var SvgSplitwiseIcon = function SvgSplitwiseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 106 106",
    style: {
      enableBackground: "new 0 0 106 106"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSplitwiseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/splitwise_icon.d81aa24d.svg";
export { ForwardRef as ReactComponent };